module.exports = __webpack_public_path__ + "9205d8e4aca6e0611849b52731c039b1.MP3";